// extracted by mini-css-extract-plugin
export default {"homeNotificationItemList":"style_homeNotificationItemList__dwG6b","wrapper":"style_wrapper__A9M8q","content":"style_content__yN5aj","contentText":"style_contentText__kXypU"};